import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'; // For dynamic route handling
import axios from 'axios';
import './OrderDetails.css'; // Mobile-friendly styles
import { useAuth } from 'react-oidc-context'; // Import the authentication hook

const OrderDetails = () => {
  const { idOrder } = useParams(); // Get order ID from URL
  console.log("idOrder:", idOrder);
  const [orderDetails, setOrderDetails] = useState(null);
  const [imageUrls, setImageUrls] = useState([]);
  const [error, setError] = useState(null);
  const auth = useAuth();

  //Upload Images
  const uploadImages = async (files) => {
    const formData = new FormData();
    Array.from(files).forEach((file) => formData.append('images', file));

    try {
        await axios.post(`https://api.currentix.de/api/images/${idOrder}/images`, formData, {
            headers: { 
              'Content-Type': 'multipart/form-data',
              'Authorization': `Bearer ${auth.user?.access_token}`,  // Add the token here
            },
      });
      alert('Images uploaded successfully!');
    } catch (err) {
      setError('Failed to upload images.');
    }
  };

  // Fetch order details
  useEffect(() => {
    const fetchOrderDetails = async () => {
        if (auth.isAuthenticated && auth.user?.access_token) {
            try {
              const response = await fetch(`https://api.currentix.de/api/complete-order/${idOrder}`, {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${auth.user.access_token}`,  // Attach the token here
                },
              });
    
              if (response.ok) {
                const data = await response.json();
                setOrderDetails(data);
              } else {
                throw new Error('Failed to fetch orders');
              }
            } catch (err) {
              setError(err.message);
            }
          }
        }
    fetchOrderDetails();
  }, [idOrder, auth]);

    // Fetch image URLs after order details are fetched
    useEffect(() => {
        const fetchImageUrls = async () => {
          if (orderDetails?.images && orderDetails.images.length > 0) {
            try {
              const imageUrlPromises = orderDetails.images.map(async (image) => {
                const imageKey = image.image_url.replace('https://currentix-attachements.s3.eu-central-1.amazonaws.com/uploads/', '');
                const response = await axios.get(`https://api.currentix.de/api/images/${imageKey}`, {
                  headers: {
                    'Authorization': `Bearer ${auth.user?.access_token}`, // Use the token to authorize the request
                  },
                });
                return response.data.imageUrl; // The signed URL from the backend
              });
    
              const urls = await Promise.all(imageUrlPromises);
              setImageUrls(urls); // Set the image URLs
            } catch (err) {
              console.error('Error fetching image URLs:', err);
              setError('Failed to fetch image URLs.');
            }
          }
        };
    
        fetchImageUrls();
      }, [orderDetails, auth.user?.access_token]);

  if (error) return <p className="error">{error}</p>;
  if (!orderDetails) return <p>Loading...</p>;

  const { order, client, appointments, orderItems } = orderDetails;

  return (
    <div className="order-details-container">
      <h1>Order Details</h1>

      {/* Order Section */}
      <section className="order-section">
        <h2>Order Information</h2>
        <p><strong>Order ID:</strong> {order.idOrder}</p>
        <p><strong>Status:</strong> {order.status}</p>
        <p><strong>Total Amount:</strong> ${order?.totalAmount}</p>
        <p><strong>Payment Status:</strong> {order?.paymentStatus}</p>
        <p><strong>Start Date:</strong> {order?.startDate}</p>
        <p><strong>End Date:</strong> {order?.endDate}</p>
        <p><strong>Work Description:</strong> {order?.workDescription}</p>
      </section>

      {/* Client Section */}
      <section className="client-section">
        <h2>Client Information</h2>
        <p><strong>Name:</strong> {client?.Name} {client?.Lastname}</p>
        <p><strong>Email:</strong> {client?.email}</p>
        <p><strong>Phone:</strong> {client?.phone}</p>
        <p><strong>Address:</strong> {client?.MapsAdress}</p>
      </section>

      {/* Appointments Section */}
      <section className="appointments-section">
        <h2>Appointments</h2>
        {appointments.length > 0 ? (
          appointments.map((appointment) => (
            <div key={appointment?.idAppointment} className="appointment-card">
              <p><strong>Status:</strong> {appointment?.status}</p>
              <p><strong>Start:</strong> {new Date(appointment?.appointmentStart).toLocaleString()}</p>
              <p><strong>Location:</strong> {appointment?.location}</p>
            </div>
          ))
        ) : (
          <p>No appointments available.</p>
        )}
      </section>

      {/* Order Items Section */}
      <section className="order-items-section">
        <h2>Order Items</h2>
        {orderItems.map((item) => (
          <div key={item?.idOrderItem} className="order-item">
            <p><strong>Description:</strong> {item?.description}</p>
            <p><strong>Quantity:</strong> {item?.quantity}</p>
            <p><strong>Unit Price:</strong> {item?.unitPrice} €</p>
            <p><strong>Total Price:</strong> {item?.totalPrice} €</p>
          </div>
        ))}
      </section>

      {/* Images Section */}
      <section className="images-section">
        <h2>Images</h2>
        <div className="images-gallery">
          {imageUrls?.length > 0 ? (
            imageUrls.map((imageUrl, index) => (
              <img
                key={index}
                src={imageUrl} // Use the fetched signed URL
                alt={`Order ${order?.idOrder}`}
              />
            ))
          ) : (
            <p>No images available.</p>
          )}
        </div>
        <input type="file" accept="image/*" multiple onChange={(e) => uploadImages(e.target.files)} />
      </section>
    </div>
  );

  
};

export default OrderDetails;
